module.exports = __webpack_public_path__ + "static/media/vietlook.6aac9aea.png";